import { createContext } from 'react';

import type { RoutingContextValue } from './routingContextTypes';

export const RoutingContext = createContext<RoutingContextValue | null>(null);
